var render = function render(){var _vm=this,_c=_vm._self._c;return _c('view-component',{attrs:{"show_filter_modal":"","show_previus_days":"","model_name":"expense"},on:{"modelSaved":_vm.modelSaved}})
}
var staticRenderFns = []

export { render, staticRenderFns }